// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import File from '@deere/cps-it.warranty-model-factory/lib/file';
import RecordAuditModalBody from './record-audit-modal-body';
import RecordAuditModalHeader from './record-audit-modal-header';
import {WarrantyMediumModal} from '../../../../shared/components/modal';

function handleActualAuditDateChange(date) {

    this.actions.updateActualAuditDate(date);

}

function closeRecordAuditModal() {

    this.actions.updateRecordAuditModalVisibility(false);

}

function handleAuditResultsChange(results) {

    this.actions.updateRecordAuditResults(results);

}

function handleFileUpload(file) {

    this.actions.updateRecordAuditFile(file);

}

function handleFileDelete(file) {

    this.actions.deleteRecordAuditFile(file);

}

function submitAuditRecord() {

    this.actions.updateAuditRecords();

}

const RecordAuditModal = props =>
    <section className='record-audit-modal'>
        <WarrantyMediumModal isOpen={props.isVisible}>
            <RecordAuditModalHeader
                city={props.city}
                leadAccountName={props.leadAccountName}
                onClose={props::closeRecordAuditModal}
                state={props.state}
            />
            <RecordAuditModalBody
                actualAuditDate={props.actualAuditDate}
                auditNumber={props.auditNumber}
                auditResults={props.auditResults}
                file={props.file}
                onActualAuditChange={props::handleActualAuditDateChange}
                onAuditResultsChange={props::handleAuditResultsChange}
                onClose={props::closeRecordAuditModal}
                onConfirm={props::submitAuditRecord}
                onFileDelete={props::handleFileDelete}
                onFileUpload={props::handleFileUpload}
            />
        </WarrantyMediumModal>
    </section>;

RecordAuditModal.displayName = 'RecordAuditModal';
RecordAuditModal.propTypes = {
    actions: PropTypes.object.isRequired,
    actualAuditDate: PropTypes.number,
    auditNumber: PropTypes.string.isRequired,
    auditResults: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    file: PropTypes.instanceOf(File).isRequired,
    isVisible: PropTypes.bool.isRequired,
    leadAccountName: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired
};

export default RecordAuditModal;



// WEBPACK FOOTER //
// ./src/tcsm/record-audit/components/record-audit-modal/record-audit-modal.js